module.exports = __webpack_public_path__ + "img/B-3.1e76fabb.png";